import { ArtButton, DAOButton } from "components/button";
import Selection, { getWalletOptions } from "components/input/select-input";
import Config from "config";
import dayjs from "dayjs";
import { CustomerInterface, TransactionInterface } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { Modal, Pagination, Table, TableCell, TableRow } from "semantic-ui-react";
import { api, ui, utils } from "services";

export const StakeTable = ({ trigger, setTrigger, myReward, setOpenStakePeriod, stakeConfig, setRecentTransaction, setWithdraw }: any) => {
    const [transactions, setTransactions] = useState([]);
    const [transactionSumInfos, setTransactionSumInfos] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(1);
    const user = useSelector((state: RootState) => state.user);
    const totalReward = myReward?.mstrStakeRevenueTime?.reduce((prev: number, cur: any) => prev + Number(cur), 0)
    const [loadingWithdraw, setLoadingWithdraw] = useState<boolean>(false);
    const [openStake, setOpenStake] = useState(false);
    const [openClaim, setOpenClaim] = useState(null);

    useEffect(() => {
        if (!sessionStorage.getItem("token") || !user?.[CustomerInterface.id]) {
            setTransactions([]);
            setTotal(0);
            return;
        }
        api
            .getStakeTransactionsInfo({
                offset: limit * (page - 1),
                limit: limit,
            })
            .then((data) => {
                setTransactions(data.transactionInfos);
                setTransactionSumInfos(data.transactionSumInfos?.sort((a: any, b: any) => a.type - b.type).map((i: any) => i.total));
                setTotal(data.total);
            })
            .catch((err) => {
                console.log({ err });
            });
    }, [trigger, user?.[CustomerInterface.id], page, limit]);

    return (
        <div className="relative">
            <Unstake open={openStake} onClose={() => setOpenStake(null)} i={openStake} trigger={trigger} setTrigger={setTrigger} setRecentTransaction={setRecentTransaction} />
            <Claim open={openClaim} onClose={() => setOpenClaim(null)} i={openClaim} trigger={trigger} setTrigger={setTrigger} setRecentTransaction={setRecentTransaction} />

            <div className="md:flex gap-y-4 md:gap-6 w-full">
                <div className="col-span-3 min-w-max">
                    <div className="bg-[#1F1D24] rounded-xl p-4 px-5">
                        <div>
                            <div className="text-white">Your total reward</div>
                            <div className="text-2xl font-bold text-[#E89F01] font-cookie mt-2">{utils.displayFloat(totalReward ?? 0, 8, false)} MSTR</div>
                        </div>
                        <div className="flex flex-wrap gap-4 mt-8 mx-auto w-full justify-center">
                            {/* <div className="w-[120px] self-center justify-center">
                                <DAOButton
                                    disabled={!user || !sessionStorage.getItem("token") || !totalReward}
                                    color="yellow" theme="light" icon="restake-icon.png"
                                    onClick={async () => {
                                        setOpenStakePeriod(true)
                                        setWithdraw(totalReward)
                                    }}
                                    className="mx-auto"
                                >
                                    Restake
                                </DAOButton>
                            </div> */}
                            <div className="w-[120px] self-center justify-center">
                                <DAOButton
                                    icon="claim-icon.png" theme="light" color="white"
                                    onClick={async () => {
                                        setOpenClaim(true)
                                    }}
                                    loading={loadingWithdraw}
                                    disabled={!user || !sessionStorage.getItem("token") || !totalReward}

                                >Claim</DAOButton>
                            </div>
                        </div>
                    </div>
                    <div className="bg-[#1F1D24] rounded-xl p-4 px-5 mt-4">
                        <div>
                            <div className="text-white text-c">Your total staked (6m/9m/12m)</div>
                            <div className="text-xl font-bold mt-1 font-cookie text-white">
                                {transactionSumInfos?.map((i: any) => utils.convertToInternationalCurrencySystem(i, 2)).join(' / ')}
                            </div>
                            <div className="bg-[#35323B] h-[2px] w-full my-8"></div>
                            <div className="text-white">Total staked (6m/9m/12m)</div>
                            <div className="text-xl font-bold mt-1 font-cookie text-white mb-8">
                                {stakeConfig?.customerTotalMstrStakeTime?.map((i: any) => utils.convertToInternationalCurrencySystem(i, 0)).join(' / ')}
                            </div>
                        </div>
                        {/* {user && <div className="self-center justify-center mx-auto w-full">
                            <div className="w-[120px] mx-auto">
                                <DAOButton color="white" theme="yellow" className="mx-auto bg-[#DF9900] text-white"
                                    disabled={!user || !sessionStorage.getItem("token")}
                                    onClick={() => {
                                        setOpenStakePeriod(true)
                                    }}
                                >Stake now</DAOButton>
                            </div>
                        </div>} */}
                    </div>
                </div>
                <div className={`md:col-span-5 overflow-x-scroll w-full mt-4 lg:mt-0 overflow-y-hidden ${!transactions?.length && "overflow-y-hidden"}`}>
                    <div className="text-[#D2D2D3] text-xl font-setOpenClaim font-cookie text-center lg:text-left">Stake list</div>
                    {!transactions?.length && <div className="gap-4 mt-2 mb-5 flex w-full justify-center self-center h-full bg-[#1F1D24]">
                        <Table ui="true" single="true" line="true" unstackable selectable inverted sortable padded className={`overflow-x-auto revenue`}>
                            <Table.Header className="sticky top-0 bg-transparent"
                                style={{ background: "transparent", zIndex: "20" }}
                            >
                                <Table.Row>
                                    {['6 months', '9 months', '12 months']?.map((header: any, idx: number) => {
                                        return <Table.HeaderCell key={`head-${idx}`} className={idx > 0 ? "border-revenue" : "border-none"}>
                                            <div className="text-center text-xl">
                                                {header}
                                            </div>
                                            <div className="text-white text-lg md:text-2xl mt-4 text-center">
                                                APR: {
                                                    utils.displayFloat(
                                                        stakeConfig?.mstrTimePool?.[idx ?? 0] * 365 * 100 / (Number(stakeConfig?.customerTotalMstrStakeTime?.[idx] ?? 0)), 2, false
                                                    ) + " %"}
                                            </div>
                                        </Table.HeaderCell>
                                    })}
                                </Table.Row>
                            </Table.Header>
                        </Table>
                    </div>
                    }
                    {/* {!transactions?.length && <div className="w-full mx-auto h-full">
                        <div className="w-[180px] mx-auto self-center justify-center flex h-full">
                            <ArtButton color="yellow" className="mx-auto "
                                disabled={!user || !sessionStorage.getItem("token")}
                                onClick={() => {
                                    setOpenStakePeriod(true)
                                }}
                            >Stake now</ArtButton>
                        </div>
                    </div>} */}

                    {!!transactions?.length && <div className="min-h-[240px] h-full max-h-[240px] md:max-h-[330px] overflow-scroll items-center">
                        {transactions.map((i, index) =>
                            <div className="bg-[#2C2B30] w-fit rounded-lg flex justify-between p-3 mt-2 text-white font-cookie" key={i.id}>
                                <div className="flex gap-4 justify-center self-center">
                                    <div>#{i.id}</div>
                                    <div className="min-w-[220px]">Unlock at: {
                                        dayjs(i.unlock_at).toDate().toLocaleTimeString(
                                            "en-us",
                                            Config.FormattedDate as any
                                        )}
                                    </div>
                                    <div className="justify-center self-center min-w-[200px] flex">
                                        <span className="mr-1">Amount: {utils.convertToInternationalCurrencySystem(i.amount, 8)}</span>
                                        <img
                                            src="/assets/images/items/mstr-icon.svg"
                                            alt="mstr"
                                            className="inline-block translate-y-[-2px]"
                                        />
                                    </div>
                                    <div className="justify-center self-center min-w-[100px] flex">
                                        {['6 months', '9 months', '12 months'][i.type ?? 0]}
                                    </div>
                                    <div className="justify-center self-center min-w-[200px] flex">
                                        <span className="mr-1">Current APR: {" "}
                                            {utils.displayFloat(
                                                stakeConfig?.mstrTimePool?.[i.type ?? 0] * 365 * 100 / (Number(stakeConfig?.customerTotalMstrStakeTime?.[i.type ?? 0] ?? 0)), 2, false
                                            ) + " %"}
                                        </span>
                                    </div>
                                </div>
                                <div className="min-w-[130px] justify-center self-center">
                                    <DAOButton
                                        disabled={!user || !sessionStorage.getItem("token") || i.is_claim}
                                        icon={!i.is_claim && "unstake-icon.png"} theme="dark" color="white"
                                        onClick={async () => {
                                            setOpenStake(i)

                                        }}
                                    >{i.is_claim ? "Unstaked" : "Unstake"}</DAOButton>
                                </div>
                            </div>
                        )}
                    </div>}

                    <div className="flex justify-end my-3">
                        {total / limit > 0 && (
                            <Pagination
                                defaultActivePage={page}
                                totalPages={Math.ceil(total / limit)}
                                onPageChange={(event: any, pageInfo) => {
                                    setPage(Number(pageInfo.activePage));
                                }}
                                firstItem={null}
                                lastItem={null}
                                className="bg-black-secondary"
                                style={{ float: "right" }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div >
    )
}

function Unstake({ open, onClose, i, trigger, setTrigger, setRecentTransaction }: any) {
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const user = useSelector((state: RootState) => state.user);
    const wallets = useSelector((state: RootState) => state.wallets);
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();
    const loginType = useSelector((state: RootState) => state.logintype);

    useEffect(() => {
        if (user?.[CustomerInterface.id]) {
            let data = getWalletOptions(wallets) ?? [];
            setOptions(data);
            let idx = data.find((i) => i.value == loginType)
            if (idx) {
                setValue(idx.value)
            } else {
                data.length > 0 && setValue(data[0].value)
            }
        }
    }, [wallets, loginType])

    async function onSubmit() {
        setLoading(true);
        try {
            let { transactionInfo } = await api.unstakePeriodMstr(i.id, value)
            setRecentTransaction(transactionInfo[TransactionInterface.id])
            window.scrollTo(0, document.body.scrollHeight);
            setTrigger(!trigger)
        } catch (err: any) {
            ui.alertFailed("Unstake failed !", t(err?.message ?? err));
        } finally {
            setLoading(false)
            close();
        }
    }
    function close() {
        setLoading(false);
        onClose();
    }

    return (
        <Modal
            size="small"
            open={open}
            style={{ width: "unset" }}
        >
            <div
                className="max-w-[564px] w-screenn"
            >
                <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
                    <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            {t("unstake")}
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

                        <div className="w-11/12 mx-auto">
                            <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                                <div className="relative w-full">
                                    <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                                        <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                                        <div className="flex">
                                            <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                                        </div>
                                    </div>
                                    <Selection
                                        setValue={setValue}
                                        options={options}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="flex w-[360px] gap-4 mt-12 text-center items-center mx-auto">
                            <ArtButton color="red"
                                className="py-3"
                                disabled={loading}
                                onClick={() => {
                                    close();
                                }}
                            >
                                {t("cancel")}
                            </ArtButton>
                            <ArtButton color="yellow"
                                className="py-3"
                                loading={loading}
                                onClick={() => {
                                    if (dayjs(i.unlock_at).isBefore(dayjs())) {
                                        onSubmit();
                                    } else
                                        ui.confirm(
                                            <div>
                                                <div className="pb-4 px-10 text-white main-font-light text-left">
                                                    {t('period_unstake_alert_msg').split('\n').map((ix) => {
                                                        return (
                                                            <div className="mt-2" dangerouslySetInnerHTML={{ __html: ix.replace('{x}', `<b>${i.penalty}</b>`) }}></div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            , onSubmit, () => { })
                                }}
                            >
                                {t("unstake")}
                            </ArtButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
}

function Claim({ open, onClose, i, trigger, setTrigger, setRecentTransaction }: any) {
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const user = useSelector((state: RootState) => state.user);
    const wallets = useSelector((state: RootState) => state.wallets);
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();
    const loginType = useSelector((state: RootState) => state.logintype);

    useEffect(() => {
        if (user?.[CustomerInterface.id]) {
            let data = getWalletOptions(wallets) ?? [];
            setOptions(data);
            let idx = data.find((i) => i.value == loginType)
            if (idx) {
                setValue(idx.value)
            } else {
                data.length > 0 && setValue(data[0].value)
            }
        }
    }, [wallets, loginType])

    async function onSubmit() {
        try {
            setLoading(true);
            let { transactionInfo } = await api.claimMstrStake(false, loginType)
            setRecentTransaction(transactionInfo[TransactionInterface.id])
            window.scrollTo(0, document.body.scrollHeight);
            setTrigger(!trigger);
            ui.alertSuccess(
                "Transaction is on processing!",
                <>You will receive your reward when transaction succeed.</>
            );
        } catch (err: any) {
            setTrigger(!trigger);
            ui.alertFailed("Withdraw reward failed !", t(err?.message ?? err));
        } finally {
            close()
        }
    }

    function close() {
        setLoading(false);
        onClose();
    }

    return (
        <Modal
            size="small"
            open={open}
            style={{ width: "unset" }}
        >
            <div
                className="max-w-[564px] w-screenn"
            >
                <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
                    <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            {t("Claim reward")}
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

                        <div className="w-11/12 mx-auto">
                            <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                                <div className="relative w-full">
                                    <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                                        <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                                        <div className="flex">
                                            <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                                        </div>
                                    </div>
                                    <Selection
                                        setValue={setValue}
                                        options={options}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="flex w-[360px] gap-4 mt-12 text-center items-center mx-auto">
                            <ArtButton color="red"
                                className="py-3"
                                disabled={loading}
                                onClick={() => {
                                    close();
                                }}
                            >
                                {t("cancel")}
                            </ArtButton>
                            <ArtButton color="yellow"
                                className="py-3"
                                loading={loading}
                                onClick={() => {
                                    ui.confirmAction("Confirm action",
                                        <>
                                            <div className="text-left">
                                                This action cannot be undone.
                                            </div>
                                            <div className="py-2 text-left">
                                                Are you sure you want to perform this action?  Please type <em>confirm</em> to confirm you action.
                                            </div>
                                        </>
                                        , "default", async () => await onSubmit())
                                }}
                            >
                                {t("unstake")}
                            </ArtButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
}
